import { Box, Checkbox } from '@mafc/trolly';
import { useTranslation } from 'react-i18next';
import React from 'react';
import COLORS from 'theme/colors';
import { IFinalPrice } from 'utils/price.util';
import OrderSummaryRow from '../../../../../common/OrderSummary/components/OrderSummaryRow';
import { createMarkup } from 'utils/html.util';
import { getCountrySpecifictermsConditionsLinks } from 'utils/getCountrySpecificLinks.utils';
import SummaryRowTypes from '../../../../../common/OrderSummary/components/OrderSummaryRow/row.types';
import useApigeeLabels from 'common/ApigeeLabels/hooks/useApigeeLabels';

interface SubtotalProps {
  priceDetails: IFinalPrice;
}

export const SubtotalTemplate: React.FC<SubtotalProps> = ({ priceDetails }) => {
  const { headerSubTotalWithVat } = useApigeeLabels();

  return (
    <OrderSummaryRow
      label={headerSubTotalWithVat}
      testId="subtotal"
      priceDetails={priceDetails}
      variant={SummaryRowTypes.header}
    />
  );
};

export const TotalDueTemplate: React.FC<SubtotalProps> = ({ priceDetails }) => {
  const { totalAmountDue } = useApigeeLabels();

  return (
    <OrderSummaryRow
      label={totalAmountDue}
      testId="total-due"
      priceDetails={priceDetails}
      variant={SummaryRowTypes.header}
    />
  );
};

interface AgreeTermsProps {
  termsSelected: boolean;
  toggleTermsCondition: (args: boolean) => void;
}
export const AgreeTermsTemplate: React.FC<AgreeTermsProps> = ({
  termsSelected,
  toggleTermsCondition,
}) => {
  const toggleTerms = () => {
    toggleTermsCondition(!termsSelected);
  };
  const { t } = useTranslation();
  return (
    <Box display="flex" flexDirection="row" alignItems="center" mt={2} mb={3}>
      <Checkbox
        borderColor={COLORS.BLUE}
        checkedBackground={COLORS.BLUE}
        checkMarkTint={COLORS.WHITE}
        onChangeCheckbox={toggleTerms}
        checked={termsSelected}
        size={20}
      />
      {/* terms url will be update later */}
      <Box
        as="span"
        color={COLORS.GREY_700}
        fontSize="13px"
        ml={2}
        dangerouslySetInnerHTML={createMarkup(
          t('shipmentLayout.termsNcondition', {
            termsUrl: getCountrySpecifictermsConditionsLinks(),
          })
        )}
      />
    </Box>
  );
};
